import { managerTimesheet } from "../../Api/managerTimesheet";
import {
  FETCH_STANDBYDETAILS_REQUEST,
  FETCH_STANDBYDETAILS_FAILURE,
  FETCH_STANDBYDETAILS_SUCCESS
} from "../../Constants";

function requestFetchstandbydetails() {
  return {
    type: FETCH_STANDBYDETAILS_REQUEST,

    isFetching: true
  };
}

function fetchstandbydetailsSuccess(data) {
  return {
    type: FETCH_STANDBYDETAILS_SUCCESS,
    isFetching: false,
    data
  };
}

function fetchstandbydetailsError(errorMessage) {
  return {
    type: FETCH_STANDBYDETAILS_FAILURE,
    isFetching: false,
    errorMessage
  };
}

export const fetchstandbydetails = payload => (dispatch, getState) => {
  dispatch(requestFetchstandbydetails());
  managerTimesheet
    .fetchstandbydetails(payload)
    .then(res => {
      dispatch(fetchstandbydetailsSuccess(res));
    })
    .catch(err => dispatch(fetchstandbydetailsError(err)));
};
export const resetstandbydetailsMessage = payload => (dispatch, getState) => {
  dispatch(fetchstandbydetailsSuccess(""));
};